import React, {useEffect, useState, Component} from 'react';
import './Dashboard.scss'
import {getPrice} from '@KrashidBuilt/hotsauce-common/dist/utils/dashboardUtils'
import {getTargetUserSalePredefined} from '../api/reports';
import {
    Button, ButtonType, Colors, ButtonTier, DateInputField, PieChart, SelectField, Table, DashboardComponent, Loader
    // DashboardComponentViewOnly
} from '../components';
import {useAppStore, useColdStore} from "../data/AppStore";
import {shallow} from "zustand/shallow";
import {useNavigate} from "react-router-dom";

const metricFilters = [
    'Today',
    'Yesterday',
    'Last Week',
    'Last Month',
    'Last Quarter',
    'Last Year',
    'WTD',
    'MTD',
    'QTD',
    'YTD',
    'LTD'
];

const Logger = require('@KrashidBuilt/hotsauce-common/dist/utils/logger');
const logger = new Logger(__filename);
const LOG_PREFIX = '[Commission.js]';

export const preDefinedRangeHandler = (selection, callback) => {
    logger.debug(LOG_PREFIX, '.preDefinedRangeHandler()', {selection});

    let startDate = new Date();
    let endDate = new Date();
    let today, quarter;

    switch (selection) {
        case 'Today':
            break;
        case 'Yesterday':
            endDate.setDate(endDate.getDate() - 1);
            startDate.setDate(startDate.getDate() - 1);
            break;
        case 'Last Week':
            endDate.setDate(endDate.getDate() - 7);
            startDate = endDate.GetFirstDayOfWeek();
            endDate = endDate.GetLastDayOfWeek();
            break;
        case 'Last Month':
            startDate.setMonth(startDate.getMonth() - 1);
            startDate.setDate(1);
            endDate = new Date(startDate);
            endDate.setMonth(endDate.getMonth() + 1);
            endDate.setDate(endDate.getDate() - 1);
            break;
        case 'Last Quarter':
            today = new Date();
            quarter = Math.floor(today.getMonth() / 3);
            startDate = new Date(today.getFullYear(), quarter * 3 - 3, 1);
            endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 3, 0);
            break;
        case 'Last Year':
            startDate.setDate(1);
            startDate.setMonth(0);
            endDate = new Date(startDate);
            endDate.setDate(startDate.getDate());
            startDate.setFullYear(endDate.getFullYear() - 1);
            break;
        case 'WTD':
            startDate.setHours(0, 0, 0, 0);
            startDate = startDate.GetFirstDayOfWeek();
            break;
        case 'MTD':
            startDate.setDate(1);
            break;
        case 'QTD':
            today = new Date();
            quarter = Math.floor(today.getMonth() / 3);
            startDate = new Date(today.getFullYear(), quarter * 3, 1);
            break;
        case 'YTD':
            startDate.setMonth(0);
            startDate.setDate(1);
            break;
        default:
            startDate = null;
            endDate = null;
            break;
    }
    logger.debug(LOG_PREFIX, '.preDefinedRangeHandler()', {startDate, endDate});
    callback(startDate, endDate);
    // this.setState({ filterTime: selection, start: startDate, end: endDate }, this.fetchSales);
};


class DashboardComponentViewOnly extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hidePie: props.hidePie || false,
            loaded: false,
            loading: false,
            error: null,
            sales: [],
            start: null,
            end: null,
            filterTime: 'LTD',
            total: 0,
            viewAmount: true,
            viewDataButton: false,
        };
    }

    componentDidMount() {
        logger.extra(LOG_PREFIX, '.componentDidMount()', {props: this.props, state: this.state});
        const {loaded} = this.state;
        if (!loaded) {
            this.fetchSales();
        }
    }

    // downloadSales = async () => {
    //   logger.extra(LOG_PREFIX, '.downloadSales()', {props: this.props, state: this.state});
    //   let {loading, start, end, filterTime} = this.state; // const
    //   const {  TodayCallback, NonTodayCallback, getAggregate, generateTotal, salesToChartData, salesToFormattedData, columns} = this.props
    //   if (loading) {
    //     return;
    //   }
    //   this.setState({loading: true}, async () => {
    //     try {
    //       if (filterTime === 'Today') { // this will change when we add back custom dates
    //         logger.extra(LOG_PREFIX, '.downloadSales()', 'custom time');
    //         let file = `Hotsauce Sales Data${start || end ? ' :' : ''}${start ? ` FROM ${start}` : ''}${end ? ` THROUGH ${end}` : ''}.csv`;
    //         let sales = await TodayCallback(start, end);
    //         let header = Object.keys(sales[0]);
    //         csv.exportCSVFileFromObject(header, sales, file);
    //       } else {
    //         logger.extra(LOG_PREFIX, '.downloadSales()', `preset time: ${filterTime}`);
    //         const report = await NonTodayCallback(filterTime);
    //         logger.extra(LOG_PREFIX, '.downloadSales()', `preset response ${JSON.stringify(report)}`);
    //         csv.openCSVFile(report[0].link, report[0].link.split('/').reverse[0]);
    //       }
    //       this.setState({loaded: true, loading: false});
    //     } catch (error) {
    //       console.log(error);
    //       this.setState({error, loading: false});
    //     }
    //   });
    // }


    // todo -- this function is changed
    fetchSales = async () => {
        logger.extra(LOG_PREFIX, '.fetchSales()', {props: this.props, state: this.state});
        const {loading, start, end, filterTime} = this.state;
        const {getAggregate, generateTotal, NonTodayCallback} = this.props

        if (loading) {
            return;
        }

        this.setState({loading: true}, async () => {
            try {
                const sales = await NonTodayCallback(filterTime);
                logger.extra(LOG_PREFIX, '.fetchSales()', `preset response ${JSON.stringify(sales)}`);
                let total = generateTotal(sales);
                logger.extra(LOG_PREFIX, '.fetchSales()', {total})
                this.setState({loaded: true, loading: false, sales, total});
            } catch (error) {
                console.log({error})
                this.setState({error, loading: false});
            }
        });
    }

    getChartDataFromSales = (amount = true) => {
        logger.extra(LOG_PREFIX, '.getChartDataFromSales()', {props: this.props, state: this.state, amount});
        const {sales} = this.state;
        const {salesToChartData} = this.props
        return salesToChartData(sales, amount)
    }


    render() {
        logger.extra(LOG_PREFIX, '.render()', {props: this.props, state: this.state});
        const {
            TodayCallback,
            NonTodayCallback,
            getAggregate,
            generateTotal,
            salesToChartData,
            salesToFormattedData,
            columns,
            pieChartTitle,
            pieChartTitleAlt,
            viewDataButton,
            altPageTitlePrefix
        } = this.props;
        const {error, loaded, loading, sales, start, end, total, filterTime, viewAmount, hidePie} = this.state;
        if (!loaded || loading) {
            return <div className={'loaderWrapper'}><Loader/></div>;
        }
        return (
            <div className={'Dashboard metrics viewOnly'}>
                {error && (
                    <div>{error.message}</div>
                )}
                <h1 dangerouslySetInnerHTML={{__html: (altPageTitlePrefix ? `${altPageTitlePrefix} <br />` : '') + getPrice(total)}}/>
                <div className={'graph-container'}>

                    {!hidePie &&
                        <PieChart
                            title={`${filterTime} ${viewAmount ? pieChartTitle : pieChartTitleAlt}`}
                            data={this.getChartDataFromSales(viewAmount)}
                        />
                    }

                    <div className={'date-filters-container'}>
                        <div>
                            <SelectField
                                label={'Pre-Defined Date Range:'}
                                className={'select-title'}
                                value={{value: filterTime, label: filterTime}}
                                options={metricFilters.map((x) => {
                                    const label = x === 'Yesterday' ? 'Previous Day w/ Sales' : x;
                                    return {value: x, label};
                                })}
                                selectedSingleValue={{value: filterTime, label: filterTime}}
                                onChange={(e) => {
                                    let filterTime = e.value !== '' ? e.value : null;
                                    preDefinedRangeHandler(filterTime, (start, end) => {
                                        this.setState({filterTime, start, end}, this.fetchSales);
                                    });
                                }}
                            />
                        </div>
                        <div className={'date-ranges'}>
                            <DateInputField
                                label={'Start'}
                                placeholder={'n/a'}
                                // className={'date'}
                                // onChange={(start) => {
                                //   (start > end) && !!end ?
                                //     this.setState({start, end: start, filterTime: null}, this.fetchSales)
                                //     :
                                //     this.setState({start, filterTime: null}, this.fetchSales);
                                // }}
                                value={start}
                                disabled={true}
                                date
                            />
                            <DateInputField
                                label={'Date'}
                                // className={'date'}
                                // onChange={(end) => {
                                //   this.setState({end, filterTime: null}, this.fetchSales);
                                // }}
                                value={end || Date.now()}
                                minDate={start}
                                disabled={true}
                                date
                            />
                        </div>
                        <div className={'date-ranges'}>
                            {viewDataButton &&
                                <Button
                                    label={`View by ${viewAmount ? 'Quantity (#)' : 'Amount ($)'}`}
                                    onClick={() => {
                                        this.setState({viewAmount: !viewAmount});
                                    }}
                                    type={ButtonType.Update}
                                    tier={ButtonTier.Secondary}
                                />
                            }
                            {/*<Button*/}
                            {/*  onClick={this.downloadSales}*/}
                            {/*  label={`Download ${start || end ? 'Filtered Metrics' : 'All Metrics'}`}*/}
                            {/*  type={ButtonType.Download}*/}
                            {/*  colorTheme={Colors.Orange}*/}
                            {/*  tier={ButtonTier.Primary}*/}
                            {/*/>*/}
                        </div>
                    </div>
                    <Table columns={columns} rows={salesToFormattedData(sales)} pageRows={25} rowPressCallback={null}/>
                </div>
            </div>
        )
    }
}


const Commission = (props) => {
    const [COMPANY, USER] = useAppStore(state => [state.COMPANY, state.USER], shallow);
    const navigate = useNavigate();

    const dataCallback = async (range = 'ltd', x, y, z) => {
        console.log('Commission', range, x, y, z, COMPANY.customerEmail)
        const data = await getTargetUserSalePredefined(USER.email, range.toLocaleLowerCase())
        console.log('DashboardComponent', {data});
        return data;
    }

    const reducerForChart = (sales) => {
        // console.log('reducer', sales)
        const data = sales.reduce((a, i) => {
            // console.log("reducer", a,i)
            if (a[i['Offering']]) {
                a[i['Offering']] = a[i['Offering']] + parseInt(i['Quantity'])
            } else {
                a[i['Offering']] = parseInt(i['Quantity'])
            }
            return (a)
        }, {})
        // console.log('reducer', data)
        return Object.entries(data).map((k) => ({y: k[1], name: k[0]}));
    }

    return (
        <section className={'Dashboard v2'}>
            <Button
                type={ButtonType.Backward}
                colorTheme={Colors.Orange}
                label={'Return Home'}
                onClick={() => navigate('/home')}
            />

            {/*<Button*/}
            {/*  type={ButtonType.Info}*/}
            {/*  colorTheme={Colors.Sage}*/}
            {/*  label={'View Company Sales'}*/}
            {/*  onClick={() => props.history.replace('/dashboard')}*/}
            {/*/>*/}

            <Button
                className={'LogoutButton'}
                label={'Logout'}
                // onClick={logout}
                type={ButtonType.Logout}
            />

            <DashboardComponentViewOnly
                hidePie={false}
                altPageTitlePrefix={`Your Commission`}
                columns={[
                    {label: 'Job', id: 'ClientJob', numeric: false},
                    {label: 'Account', id: 'ClientAccount', numeric: false},
                    {label: 'Offering', id: 'Offering', numeric: false},
                    {label: 'Customer Name', id: 'CustomerName', numeric: false},
                    {
                        id: 'SalesAmount',
                        numeric: true,
                        label: 'Sales Total',
                        align: 'right',
                        format: (value) => getPrice(value)
                    },
                    {
                        id: 'EarnedSaleCommission',
                        numeric: true,
                        label: 'Earned Sale Commission',
                        align: 'right',
                        format: (value) => getPrice(value)
                    },
                ]}
                pieChartTitle={`${USER.email}'s earned Commission`}
                TodayCallback={dataCallback}
                NonTodayCallback={dataCallback}
                getAggregate={dataCallback}
                generateTotal={(sales) => (sales.map((s) => parseInt(s['Earned Sale Commission'].replaceAll('$', '').replaceAll(',', '') * 100)).reduce((a, b) => a + b, 0))}
                salesToChartData={(sales) => (reducerForChart(sales))}
                salesToFormattedData={(sales => (
                    sales.map(s => ({
                        ClientJob: s['Job'],
                        ClientAccount: s['Account'],
                        CustomerEmail: s['Client Email'],
                        CustomerName: s['Client Name'],
                        'Offering': s['Offering'],
                        'SalesAmount': parseInt(s['Sales Amount'].replaceAll('$', '').replaceAll('.', '').replaceAll(',', '')),
                        'EarnedSaleCommission': parseInt(s['Earned Sale Commission'].replaceAll('$', '').replaceAll('.', '').replaceAll(',', '')),
                    }))
                ))}
            />
        </section>
    )
};

export default Commission;
